module.exports = __webpack_public_path__ + "img/1x.930819f8.png";